// extracted by mini-css-extract-plugin
module.exports = {"container":"landingpage_container__1OaYz","container2":"landingpage_container2__3WB5R","h1":"landingpage_h1__3dzu7","hi":"landingpage_hi__36E9t"};